var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Mapa de Hallazgos ")]),_c('br'),_c('br'),_c('div',{staticStyle:{"background":"lightgrey"}},[_c('iframe',{attrs:{"src":"https://www.google.com/maps/d/embed?mid=1tRBg3ZwV4pa6ICHvU9v4aESKw0HFtPo&ehbc=2E312F&noprof=1","width":"100%","height":"700"}})])])
}]

export { render, staticRenderFns }